import React from 'react';
import { Pivot, PivotItem, Text, IconButton, Icon, DirectionalHint } from '@fluentui/react';
import ClubImageCircle from '../Common/ClubImageCircle';
import { todosContraTodos, Torneo, Partido, Planilla } from '../../system/SystemClient';
import { genkey } from '../../common/constants';
import { useBoolean, useId } from '@fluentui/react-hooks';
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Callout, Link, mergeStyleSets, FontWeights } from '@fluentui/react';
import { DateTime } from 'luxon';
import { HIDDEN_LIMIT_DOWN, PendienteConfirmacionCallout, PlanillasCallout } from './PartidoFixture';

interface IPartidoDesktop {
  partido: Partido;
  openCalloutOrOpenPDF: (planillas: Planilla[], openCallout: () => void) => void;
  openCalloutOrOpenVideo: (planillas: Planilla[], openCallout: () => void) => void;
  openMap: (campoJuegoCoords: string) => void;
  getStylesBy: (id: string) => React.CSSProperties | undefined;
  openMapWithDireccion: (campoJuegoDireccion: string) => void;
}

export const PartidoDesktop = ({
  partido,
  openCalloutOrOpenPDF,
  openCalloutOrOpenVideo,
  openMap,
  getStylesBy,
  openMapWithDireccion,
}: IPartidoDesktop) => {
  const [isCalloutPlanillaVisibleDesktop, { toggle: toggleIsCalloutVisibleDesktop }] = useBoolean(false);
  const buttonIdDesktop = useId(genkey());
  const labelIdDesktop = useId(genkey());
  const descriptionIdDesktop = useId(genkey());

  const [
    isCalloutPendienteConfirmacionVisibleDesktop,
    { toggle: toggleIsCalloutPendienteConfirmacionVisibleDesktop },
  ] = useBoolean(false);
  const buttonIdPendienteConfirmacionDesktop = useId(genkey());
  const labelIdPendienteConfirmacionDesktop = useId(genkey());
  const descriptionIdPendienteConfirmacionDesktop = useId(genkey());

  const [isCalloutCampoJuegoVisibleDesktop, { toggle: toggleIsCalloutCampoJuegoVisibleDesktop }] =
    useBoolean(false);
  const labelIdCampoJuegoDesktop = useId(genkey());
  const descriptionIdCampoJuegoDesktop = useId(genkey());
  const buttonIdCampoJuegoDesktop = useId(genkey());

  const [isCalloutArbitrosVisibleDesktop, { toggle: toggleIsCalloutArbitrosVisibleDesktop }] =
    useBoolean(false);
  const labelIdArbitrosDesktop = useId(genkey());
  const descriptionIdArbitrosDesktop = useId(genkey());
  const buttonIdArbitrosDesktop = useId(genkey());

  const winnerClass = (golesPropios: number, golesAComparar: number) => {
    return golesPropios > golesAComparar;
  };

  return (
    <div id="viewDesktop" className={`${HIDDEN_LIMIT_DOWN}`}>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12 mt-1">
          <div className="ms-Grid-col ms-sm2  text-overflow " style={{ marginTop: 9, width: '14.66%' }}>
            <Text
              style={{
                fontSize: 14,
                float: 'left',
                marginLeft: 10,
              }}
              className="mb-1"
              variant="medium"
            >
              {!partido.isGhostMatch && (
                <>
                  <Icon
                    iconName="Calendar"
                    className="text-icon"
                    style={{ fontSize: '16px !important' }}
                  ></Icon>
                  {DateTime.fromFormat(partido.horario, 'yyyy/LL/dd HH:mm:ss')
                    .setLocale('es')
                    .toFormat('ccc dd LLLL HH:mm')}
                </>
              )}
            </Text>
          </div>

          <div className="ms-Grid-col ms-sm3 text-overflow" style={{ minHeight: 40, width: '30%' }}>
            <div className="ms-Grid-col ms-sm10 text-overflow" style={{ minHeight: 40 }}>
              <Text
                className="mb-1 nombre-equipo-fixture nombre-local"
                variant="medium"
                style={getStylesBy(partido.idClubLocal)}
              >
                {partido.nombreLocal}
              </Text>
            </div>

            <div className="ms-Grid-col ms-sm2" style={{ minHeight: 40 }}>
              <div>
                <ClubImageCircle
                  escudo={partido.escudoImagePathLocal}
                  width={35}
                  height={35}
                  right
                ></ClubImageCircle>
              </div>
            </div>
          </div>
          <div className={`ms-Grid-col ms-sm2 `} style={{ marginTop: 5, width: '11%', minWidth: 90 }}>
            {!partido.isGhostMatch && (partido.played || partido.playing) ? (
              <div
                style={{ fontWeight: 600, color: 'black', fontSize: 18, display: 'inline-flex' }}
                title={partido.pendingConfirmation ? 'Partido pendiente de confirmación' : ''}
              >
                <div
                  style={{ width: '100%' }}
                  className={` ${partido.playing ? 'cool-link' : ''} ${
                    partido.pendingConfirmation
                      ? 'pending-confirmation-local pending-confirmation-visitante'
                      : ''
                  }`}
                >
                  <div
                    className={
                      winnerClass(+partido.golesLocal, +partido.golesVisitante)
                        ? 'winner score'
                        : 'loser score'
                    }
                  >
                    {partido.golesLocal}
                  </div>{' '}
                  <div
                    className={
                      winnerClass(+partido.golesVisitante, +partido.golesLocal)
                        ? 'winner score'
                        : 'loser score'
                    }
                  >
                    {partido.golesVisitante}
                  </div>
                </div>
              </div>
            ) : (
              <span>Vs</span>
            )}
          </div>
          <div className="ms-Grid-col ms-sm3 text-overflow" style={{ minHeight: 40, width: '30%' }}>
            <div className="ms-Grid-col ms-sm2" style={{ minHeight: 40 }}>
              <div>
                <ClubImageCircle
                  escudo={partido.escudoImagePathVisitante}
                  width={35}
                  height={35}
                ></ClubImageCircle>
              </div>
            </div>

            <div className="ms-Grid-col ms-sm10 text-overflow" style={{ minHeight: 40 }}>
              <Text
                className="mb-1 nombre-equipo-fixture nombre-visitante"
                style={getStylesBy(partido.idClubVisitante)}
                variant="medium"
              >
                {!partido.isGhostMatch ? partido.nombreVisitante : 'LIBRE'}
              </Text>
            </div>
          </div>
          <div
            className="ms-Grid-col ms-sm2  text-overflow "
            style={{ marginTop: 9, width: '13.66%', textAlign: 'left' }}
          >
            {!partido.isGhostMatch && (
              <div className="ms-Grid-col ms-sm12  text-overflow " style={{ textAlign: 'left' }}>
                <PrimaryButton
                  iconProps={{ iconName: 'PublishCourse' }}
                  title="Ver arbitros"
                  id={buttonIdArbitrosDesktop}
                  className="float-right ml-2 "
                  onClick={toggleIsCalloutArbitrosVisibleDesktop}
                  disabled={!!!partido.arbitros}
                  styles={{
                    root: {
                      border: !!!partido.arbitros ? undefined : '1px solid #00b2ff',
                      background: !!!partido.arbitros ? undefined : '#00b2ff',
                      borderRadius: 25,
                      padding: 0,
                      minWidth: 25,
                      height: 27,
                    },
                  }}
                ></PrimaryButton>
                <PrimaryButton
                  iconProps={{ iconName: 'POI' }}
                  title="Ver estadio"
                  id={buttonIdCampoJuegoDesktop}
                  className="float-right ml-2 "
                  onClick={toggleIsCalloutCampoJuegoVisibleDesktop}
                  styles={{
                    root: {
                      border: '1px solid #009454',
                      background: '#009454',
                      borderRadius: 25,
                      padding: 0,
                      minWidth: 25,
                      height: 27,
                    },
                  }}
                ></PrimaryButton>

                {partido.pendingConfirmation ? (
                  <PrimaryButton
                    iconProps={{ iconName: 'AccountActivity' }}
                    id={buttonIdPendienteConfirmacionDesktop}
                    onClick={() => toggleIsCalloutPendienteConfirmacionVisibleDesktop()}
                    styles={{
                      root: {
                        border: '1px solid #f79c25',
                        background: '#f79c25',
                        borderRadius: 25,
                        padding: 0,
                        minWidth: 25,
                        height: 27,
                      },
                    }}
                    className="float-right ml-2 "
                  ></PrimaryButton>
                ) : (
                  <PrimaryButton
                    iconProps={{ iconName: 'AccountActivity' }}
                    id={buttonIdDesktop}
                    onClick={() => openCalloutOrOpenPDF(partido.planillas, toggleIsCalloutVisibleDesktop)}
                    styles={{ root: { borderRadius: 25, padding: 0, minWidth: 25, height: 27 } }}
                    title="Ver planilla"
                    className="float-right ml-2 "
                    disabled={partido.planillas.filter((planilla) => planilla.pdf).length === 0}
                  ></PrimaryButton>
                )}

                {partido.planillas.some((planilla) => planilla.url_transmision) && (
                  <PrimaryButton
                    iconProps={{ iconName: 'Video' }}
                    className="float-right "
                    title="Ver transmisión"
                    id={buttonIdDesktop}
                    onClick={() => openCalloutOrOpenVideo(partido.planillas, toggleIsCalloutVisibleDesktop)}
                    styles={{
                      root: {
                        border: '1px solid #f79c25',
                        background: '#f79c25',
                        borderRadius: 25,
                        padding: 0,
                        minWidth: 25,
                        height: 27,
                      },
                    }}
                  ></PrimaryButton>
                )}

                <>
                  {isCalloutPlanillaVisibleDesktop && (
                    <Callout
                      ariaLabelledBy={labelIdDesktop}
                      ariaDescribedBy={descriptionIdDesktop}
                      role="dialog"
                      gapSpace={0}
                      target={`#${buttonIdDesktop}`}
                      onDismiss={toggleIsCalloutVisibleDesktop}
                      setInitialFocus
                      className={styles.callout}
                      directionalHint={DirectionalHint.leftCenter}
                    >
                      <PlanillasCallout partido={partido} labelId={labelIdDesktop}></PlanillasCallout>
                    </Callout>
                  )}
                </>

                <>
                  {isCalloutPendienteConfirmacionVisibleDesktop && (
                    <Callout
                      ariaLabelledBy={labelIdPendienteConfirmacionDesktop}
                      ariaDescribedBy={descriptionIdPendienteConfirmacionDesktop}
                      role="dialog"
                      gapSpace={0}
                      target={`#${buttonIdPendienteConfirmacionDesktop}`}
                      onDismiss={toggleIsCalloutPendienteConfirmacionVisibleDesktop}
                      setInitialFocus
                      className={styles.callout}
                      directionalHint={DirectionalHint.leftCenter}
                    >
                      <PendienteConfirmacionCallout></PendienteConfirmacionCallout>
                    </Callout>
                  )}
                </>

                <>
                  {isCalloutCampoJuegoVisibleDesktop && (
                    <Callout
                      ariaLabelledBy={labelIdCampoJuegoDesktop}
                      ariaDescribedBy={descriptionIdCampoJuegoDesktop}
                      role="dialog"
                      gapSpace={0}
                      target={`#${buttonIdCampoJuegoDesktop}`}
                      onDismiss={toggleIsCalloutCampoJuegoVisibleDesktop}
                      setInitialFocus
                      className={styles.callout}
                      directionalHint={DirectionalHint.leftCenter}
                    >
                      <span style={{ margin: 10, fontSize: 14, fontWeight: 500 }}>
                        {partido.campoJuegoNombre}
                      </span>
                      {partido.campoJuegoCoords ? (
                        <span
                          className="link-styles"
                          onClick={() => openMap(partido.campoJuegoCoords)}
                          style={{ marginLeft: 10, fontSize: 12, fontWeight: 500, display: 'block' }}
                        >
                          Ver dirección
                        </span>
                      ) : (
                        <div>
                          {partido.campoJuegoDireccion && (
                            <span
                              className="link-styles"
                              onClick={() => openMapWithDireccion(partido.campoJuegoDireccion)}
                              style={{ marginLeft: 10, fontSize: 12, fontWeight: 500, display: 'block' }}
                            >
                              Ver dirección
                            </span>
                          )}
                        </div>
                      )}
                    </Callout>
                  )}
                </>

                <>
                  {isCalloutArbitrosVisibleDesktop && (
                    <Callout
                      ariaLabelledBy={labelIdArbitrosDesktop}
                      ariaDescribedBy={descriptionIdArbitrosDesktop}
                      role="dialog"
                      gapSpace={0}
                      target={`#${buttonIdArbitrosDesktop}`}
                      onDismiss={toggleIsCalloutArbitrosVisibleDesktop}
                      setInitialFocus
                      className={styles.callout}
                      directionalHint={DirectionalHint.leftCenter}
                    >
                      <div>
                        <div>
                          <span style={{ margin: 10, fontSize: 14, fontWeight: 500 }}>Arbitros</span>
                        </div>
                        <div>
                          <span style={{ margin: 10, fontSize: 14, fontWeight: 400 }}>
                            {partido.arbitros ? partido.arbitros : 'Aun no designados'}
                          </span>
                        </div>
                      </div>
                    </Callout>
                  )}
                </>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = mergeStyleSets({
  button: {
    width: 130,
  },
  callout: {
    width: 320,
    maxWidth: '90%',
    padding: '6px 10px',
  },
  title: {
    marginBottom: 12,
    fontWeight: FontWeights.semilight,
  },
  link: {
    display: 'block',
    marginTop: 20,
  },
});
